/* eslint no-param-reassign: 0 */
import React from 'react';
import { connect } from 'react-redux';

import DatePicker from '~/components/DatePicker';
import { list2 as getWork } from '~/actions/work';
import {
  isEqual as isEqualDate,
  getDateRange,
  toFromDate,
  toToDate
} from '~/utils/dateHelpers';
import Tag from '~/components/Tag';

import Styles from './widget.scss';

class ShippedStats extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    const dateRange = getDateRange(
      props.indata.from,
      props.indata.to,
      props.indata.period
    );

    this.state = {
      from: dateRange.from,
      to: dateRange.to,
      previousFrom: dateRange.from,
      previousTo: dateRange.to,
      loading: false,
      works: []
    };
  }

  componentDidMount() {
    this.fetchInterval = setInterval(this.fetchWork.bind(this), 300000);
    this.fetchWork();
  }

  componentWillReceiveProps(nextProps) {
    const dateRange = getDateRange(
      nextProps.indata.from,
      nextProps.indata.to,
      nextProps.indata.period
    );
    if (
      !isEqualDate(toFromDate(this.state.previousFrom), dateRange.from) ||
      !isEqualDate(toToDate(this.state.previousTo), dateRange.to) ||
      this.props.indata.actionId !== nextProps.indata.actionId
    ) {
      this.setState(
        {
          from: dateRange.from,
          to: dateRange.to,
          previousFrom: dateRange.from,
          previousTo: dateRange.to
        },
        this.fetchWork
      );
    }
  }

  componentWillUnmount() {
    if (this.fetchInterval) {
      clearInterval(this.fetchInterval);
    }
  }

  fetchWork(skipId) {
    const { from, to } = this.state;
    this.setState({ loading: true });
    getWork(
      this.props.dispatch,
      this.context.apiClient,
      null,
      skipId,
      this.props.indata.actionId,
      null,
      null,
      true,
      from,
      to
    ).then(r => {
      this.setState({
        works: skipId
          ? [...this.state.works, ...r.data.results]
          : r.data.results
      });
      if (r.data.more) {
        this.fetchWork(r.data.skipId);
      }
    });
  }

  render() {
    const {
      title,
      showDateFields,
      countVisibility,
      hideOrderList
    } = this.props.indata;
    const { works } = this.state;
    return (
      <div className={`${this.props.className} ${Styles.widget}`}>
        <h5 className={Styles.title}>{title}</h5>
        <div className={Styles.content}>
          {showDateFields && (
            <div>
              <div className="pullLeft" style={{ width: '50%' }}>
                <DatePicker
                  label="From"
                  locale="us"
                  sundayFirstDayOfWeek
                  onChange={from => {
                    this.setState({ from }, this.fetchWork);
                  }}
                  value={this.state.from}
                />
              </div>
              <div className="pullRight" style={{ width: '50%' }}>
                <DatePicker
                  label="To"
                  locale="us"
                  sundayFirstDayOfWeek
                  onChange={to => {
                    this.setState({ to }, this.fetchWork);
                  }}
                  value={this.state.to}
                />
              </div>
              <div className="clear" />
            </div>
          )}
          {countVisibility !== 'none' && (
            <div className={Styles.countContainers}>
              <div className={Styles.countContainer}>
                <span className={Styles.count}>
                  {works.length} container{works.length === 1 ? '' : 's'}
                </span>{' '}
                shipped
              </div>
            </div>
          )}
          {!hideOrderList && (
            <div className={Styles.orders}>
              {works.slice(0, 60).map(work => {
                const { containerId } = work.data;
                const container =
                  containerId && this.props.containers.get(containerId);
                const orderId = container && container.get('orderId');
                return (
                  <div className={Styles.orderContainer} key={work.id}>
                    <div className={Styles.order}>
                      #{work.sku}
                      <div className={Styles.boxes}>
                        <span className={Styles.boxToggler}>
                          {orderId && <Tag type="order" id={orderId} />}
                          {containerId && (
                            <Tag type="container" id={containerId} />
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  containers: state.getIn(['containers', 'items'])
});

// Setting pure: false is required for react router to work
export default connect(
  mapStateToProps,
  null,
  null,
  { pure: false }
)(ShippedStats);



// WEBPACK FOOTER //
// ./app/widgets.new/ShippedStats/widget.js